var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{attrs:{"width":`${_vm.width}`,"height":`${_vm.height}`,"src":"https://tokens.gala.games/gala-film/film-token.png","alt":"$FILM"}})
}
var staticRenderFns = []

export { render, staticRenderFns }